export const MARKET_CANDIDATES_DICT = {
    "HOME": "Casa",
    "DRAW": "Empate",
    "AWAY": "Visitante",
    "ASIAN_UNDER_GOALS": "Under Gols",
    "ASIAN_OVER_GOALS": "Over Gols",
}
